import { Component, ElementRef, OnInit, AfterViewInit, ViewChild, Directive, Input } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { Promotion } from '../../models/marketing.model';
import { MarketingService, CommonService } from '../../services';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { AuthService } from '../../services/auth.service';

declare var jQuery: any;
// declare var $;

@Component({
    selector: '<vertical-banner>',
    templateUrl: 'vertical-banner.html'
})

export class VerticalBannerComponent implements OnInit, AfterViewInit {

    @Input() bannerLocation: string = "";
    @Input() banners: Array<Promotion> = [];
    bannerList = new Array<Promotion>();
    selectedBannerList = new Array<Promotion>();

    updatedBanners: number[] = [];
    currentUserModel: CurrentUserModel = {} as CurrentUserModel;
    accountId: string = "";
    loginId: string = "";
    counter = 0;
    // @ViewChild('owlBanner') owlBanner: OwlCarousel;
    // @Input() index;

    constructor(private elementRef: ElementRef,
        private router: Router,
        private commonService: CommonService,
        private marketingService: MarketingService,
        private authService: AuthService,
        private carouselConfig: NgbCarouselConfig
    ) {

        carouselConfig.interval = 10000;
        // config.wrap = true;
        carouselConfig.keyboard = false;
        //carouselConfig.showNavigationArrows = false;
    }

    ngOnInit() {
        this.marketingService.getPromotionList('B', this.commonService.getBannerLocationId(this.bannerLocation)).subscribe((result: Array<Promotion>) => {
            const randomIndex = Math.floor(Math.random() * this.bannerList.length);
            if(result && result.length > 0){
                
                this.bannerList = result.filter(x => x.startDate && new Date().setHours(0,0,0,0) >= new Date(x.startDate).setHours(0,0,0,0));
                //console.log(this.bannerList);
                // console.log(new Date(this.bannerList[0].startDate).setHours(0,0,0,0));
                // console.log(new Date().setHours(0,0,0,0));
                //this.bannerList.forEach(bannerItem => {
                //    if (this.commonService.checkIfValidUrl(bannerItem.cloudFileName)) {
                //        bannerItem.isBannerDirectUrl = true;
                //    } else {
                //        bannerItem.isBannerDirectUrl = false;
                //    }
                //});
                this.selectedBannerList = this.bannerList;
                if (this.selectedBannerList.length > 0) this.updateImpressions(this.selectedBannerList[0].id);
                this.counter = 1;
            }
            // if(this.bannerList.length > 0)
            //     this.selectedBannerList.push(this.bannerList[randomIndex]);
            //console.log(this.bannerList);
        })
    }

    ngAfterViewInit() {
    }

    onSlide(event: any) {
        if (event && this.counter < this.selectedBannerList.length) {
            var indexArr = event.current.split('-');
            var index = indexArr[indexArr.length - 1];
            let bannerId = this.selectedBannerList[index]?.id;
            this.updateImpressions(bannerId);
            this.counter++;
            // console.log(index);
            // console.log();
        }
    }

    updateImpressions(bannerId: number) {
        if (bannerId > 0) {
            //if (bannerId > 0 && this.accountId != '' && !this.updatedBanners.includes(bannerId)) {
            this.marketingService.UpdatePromotionAnalytics(bannerId, 'I').subscribe(value => {
                //this.bannerLocations = value;
                this.updatedBanners.push(bannerId);
            });
        }
    }

    // onBannerClicked(bannerId: number) {
    //     debugger;
    //     if (bannerId > 0) {
    //         this.marketingService.UpdatePromotionAnalytics(bannerId, 'C').subscribe(value => {
    //             //this.bannerLocations = value;
    //         });
    //     }
    // }

    onBannerClicked(banner: Promotion) {
        //debugger;
        if (banner.id > 0) {
            this.marketingService.UpdatePromotionAnalytics(banner.id, 'C').subscribe(value => {
                //this.bannerLocations = value;
            });
            window.open(banner.promotionLink, "_blank");
        }
    }

    displayDirectUrl(banner: Promotion)
    {
        if(this.commonService.checkIfValidUrl(banner.cloudFileName)){
            return true;
        }
        return false;
    }
}
